import { useEffect, useContext, useRef } from "react";
import { Context } from "./Context";
import {
  AllEquipmentButton,
  AllEquipments,
  AllRoom,
  AllScenario,
  DevicesList,
  GetNotificationStatus,
} from "../api/api";

const FetchData = () => {
  const {
    token,
    authUser,
    setRooms,
    setEquipments,
    setDevices,
    setEquipmentButtons,
    setScenarios,
    setScenarioCommands,
    setNotificationStatus,
    setIsLoading,
  } = useContext(Context);

  // استفاده از ref برای جلوگیری از fetch مجدد
  const hasFetchedRef = useRef(false);
  const lastAuthUserIdRef = useRef(null);

  useEffect(() => {
    if (!authUser) return;

    // اگر قبلاً fetch شده و کاربر همان است، دیگر fetch نکن
    if (hasFetchedRef.current && lastAuthUserIdRef.current === authUser.id) {
      return;
    }

    let isMounted = true;

    const fetchAllData = async () => {
      setIsLoading(true);

      try {
        const [
          devicesRes,
          equipmentsRes,
          roomsRes,
          equipmentButtonsRes,
          scenariosRes,
        ] = await Promise.all([
          DevicesList(),
          AllEquipments({ user_id: authUser.id }),
          AllRoom({ user_id: authUser.id }),
          AllEquipmentButton({ user_id: authUser.id }),
          AllScenario(),
        ]);
        
        GetNotificationStatus({
          api_key: authUser.apikey,
          token: token,
        }).then(notificationStatusRes => {
          setNotificationStatus(notificationStatusRes.data.status);
          localStorage.setItem(
            "get_notification_status",
            notificationStatusRes.data.status,
          );
        }).catch(err => {
          // console.log(err);
        });

        if (!isMounted) return;

        setDevices(
          devicesRes.data.devices.map((d) => ({
            ...d,
            type: Number(d.type),
          })),
        );
        setEquipments(equipmentsRes.data.equipments);
        setRooms(roomsRes.data.rooms);
        setEquipmentButtons(equipmentButtonsRes.data.equipment_buttons);
        setScenarios(scenariosRes.data.scenarios);
        setScenarioCommands(scenariosRes.data.scenario_commands);
        
        // ثبت در ref که fetch انجام شده
        hasFetchedRef.current = true;
        lastAuthUserIdRef.current = authUser.id;
      } catch (error) {
        console.error("FetchData error:", error);
      } finally {
        if (isMounted) {
          setIsLoading(false);
        }
      }
    };

    fetchAllData();

    return () => {
      isMounted = false;
    };
  }, [authUser, token]); // وابستگی‌ها باقی می‌مانند ولی با ref کنترل می‌شوند

  return null;
};

export default FetchData;